export { default as Headline, type Alignment } from './Headline';
